import { useSettings } from '../hooks/useSettings';

interface HeaderProps {
  title: React.ReactNode;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
  compact?: boolean;
}

export function Header({ title, subtitle, actions, className, compact }: HeaderProps) {
  const { settings, loading } = useSettings();

  return (
    <header className={`bg-white/10 backdrop-blur-md border-b border-white/20 px-6 ${compact ? 'py-[0.9rem]' : 'py-4'} relative z-[1000] ${className || ''}`}>
      <div className="flex items-center justify-between">
        {/* Título e Subtítulo */}
        <div className="flex items-center space-x-4">
          {/* Logo da empresa no header */}
          <div className="flex items-center space-x-3">
            {!loading && (
              <img
                src={settings?.logoUrl || '/assets/bchatlogo.png'}
                alt={settings?.companyName || 'BChat'}
                className="h-8 w-auto object-contain"
                onError={(e) => {
                  // Fallback se a imagem customizada falhar
                  (e.target as HTMLImageElement).src = '/assets/bchatlogo.png';
                }}
              />
            )}
            {loading && (
              <div className="h-8 w-24 bg-white/10 animate-pulse rounded"></div>
            )}
            <div className="border-l border-white/20 pl-3">
              <h1 className="text-xl font-bold text-white font-oswald tracking-wide uppercase">{title}</h1>
              {subtitle && (
                <p className="text-sm text-gray-300 font-medium">{subtitle}</p>
              )}
            </div>
          </div>
        </div>

        {/* Ações da direita */}
        <div className="flex items-center space-x-4">
          {/* Ações customizadas */}
          {actions && (
            <div className="flex items-center space-x-2">
              {actions}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
